import './App.css';
import { useEffect, useState } from 'react';
import SignInSide from './views/signin/SignIn';
import OAuthCallback from './views/signin/OAuthCallback';
import { BrowserRouter, Route, Routes} from 'react-router-dom';
import { getUserDetails } from './api/auth';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Frame from './views/Frame';
import { ReactNotifications } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'

function App() {
  const [user, setUser] = useState({"status": "unknown"});

  const onUserLogin = (r) => {
    let user_state = {"status": "authed", ...r}
    setUser(user_state);
  };

  const onUnauthedUser = (r) => {
    setUser({"status": "unauthed"});
  };

  useEffect(() => {
    getUserDetails().then(onUserLogin).catch(onUnauthedUser);
  }, []);

  const setLoggedIn = () => {
    setUser({"status": "authing"});
    getUserDetails().then(onUserLogin).catch(onUnauthedUser);
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: '#00d2ff',
      },
      secondary: {
        main: '#333a61',
      },
      tertiary: {
        main: '#cd3c4d',
        contrastText: '#fff',
      },
      green: {
        main: '#00d27a',
        contrastText: '#fff',
      },
      text: {
        primary: 'rgb(39, 47, 77)',
        secondary: '#333a61',
        light: '#8e8e8e',
      },
      error: {
        main: '#cd3c4d',
        contrastText: '#fff',
      },
    },
    typography: {
      h2: {
        color: "#007e99",
        fontSize: '1.3rem',
        fontWeight: 400,
        fontStyle: 'normal',
        letterSpacing: '0em',
      },
      h3: {
        color: "#007e99",
        fontSize: '1.2rem',
        fontWeight: 400,
        fontStyle: 'normal',
        letterSpacing: '0em',
      },
      h4: {
        color: "#333a61",
        fontSize: '1.5rem',
        fontWeight: 500,
        fontStyle: 'normal',
        letterSpacing: '0em',
      },
      h5: {
        color: "#333a61",
        fontSize: '1.2rem',
        fontWeight: 500,
        fontStyle: 'normal',
        letterSpacing: '0em',
      },
      fontFamily: [
        '"DM Sans"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
      button: {
        fontWeight: 500,
        fontSize: '14px',
        textTransform: 'none',
      },
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: 'rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px',
            transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)',
          },
        },
      },
    }
  });

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<SignInSide setLoggedIn={setLoggedIn} />} />
          <Route path="/me" element={<div>{JSON.stringify(user)}</div>} />
          <Route path="/oauth/callback" element={<OAuthCallback setLoggedIn={setLoggedIn} />} />
          <Route path="/*" element={<Frame user={user} />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
    <ReactNotifications />
    </div>
  );
}

export default App;
